import { Fragment } from 'react';

import { styled } from '@mui/material';

import { IconButtonGhostMini } from '../IconButtonGhostMini';
import { Popover, useBasicPopover } from '../Popover';
import { PopoverContent } from '../PopoverContent';
import { infoButtonClasses } from './theme';
import {
  ARROW_TO_PLACEMENT_MAP,
  type InfoButtonOwnerState,
  type InfoButtonWithPopoverProps,
} from './types';

const InfoButtonWithPopover = (props: InfoButtonWithPopoverProps) => {
  const {
    popoverContentProps,
    popoverProps,
    arrow = 'down',
    children,
    color = 'default',
    ...others
  } = props;

  const ownerState: InfoButtonOwnerState = {
    ...props,
    alertType: 'popover',
    arrow,
    color,
  };

  const { anchorEl, onClick, open, id, onClose } = useBasicPopover<HTMLButtonElement>();
  const placement = ARROW_TO_PLACEMENT_MAP[arrow];

  return (
    <Fragment>
      <InfoButtonIcon onClick={onClick} ownerState={ownerState} {...others}>
        {children}
      </InfoButtonIcon>
      <Popover
        {...popoverProps}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        placement={placement}
      >
        <PopoverContent {...popoverContentProps} placement={placement} arrow={true} />
      </Popover>
    </Fragment>
  );
};

export default InfoButtonWithPopover;

const InfoButtonIcon = styled(IconButtonGhostMini, {
  target: infoButtonClasses.icon,
})<{ ownerState: InfoButtonOwnerState }>`
  & svg {
    color: ${({ ownerState, theme }) => {
      if (ownerState.color === 'red') return theme.color['icon/danger/default'];
      if (ownerState.color === 'yellow') return theme.color['icon/warning/default'];
      return theme.color['icon/weaker/default'];
    }};
  }
`;
